import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild} from '@angular/core';
import { Chart } from 'chart.js/auto';
import { ChartDataset } from 'chart.js';
import { RisorseCounter } from '../../../_models/RisorseCounter';

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss'],
    standalone: false
})
export class PieChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() bars: RisorseCounter[] = [];
  @Input() colors?: string[];
  @ViewChild('pieCanvas') canvasRef?: ElementRef<HTMLCanvasElement>;
  public chart: Chart;
  private viewInitialized = false;

  get hasData(): boolean {
    return !!this.bars && this.bars.some(b => (b.workingTimeOfToday ?? 0) > 0);
  }

  ngAfterViewInit() {
    this.viewInitialized = true;
    this.createChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.viewInitialized && changes['bars']) {
      setTimeout(() => this.createChart(), 0);
    }
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  createChart(){
    if (!this.canvasRef) {
      return;
    }
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    if (!this.bars || this.bars.length === 0) {
      return;
    }
    const valid = this.bars.filter(b => (b.workingTimeOfToday ?? 0) > 0);
    if (valid.length === 0) {
      return;
    }
    const labels: (string | number)[] = [];
    const datas: number[] = [];
    valid.forEach((bar: RisorseCounter) => {
      labels.push(bar.risorsaCodice ?? bar.risorsaId);
      datas.push(bar.workingTimeOfToday / 3600);
    });
    const dataset: ChartDataset<'doughnut', number[]> = { label: 'Ore lavorate', data: datas };
    if (this.colors && this.colors.length > 0) {
      dataset.backgroundColor = datas.map((_, i) => this.colors![i % this.colors!.length]);
    }
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    this.chart = new Chart(this.canvasRef.nativeElement, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [dataset]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: isMobile ? 'bottom' : 'top',
            labels: {
              boxWidth: isMobile ? 12 : 16,
              boxHeight: isMobile ? 10 : 12,
              padding: isMobile ? 8 : 12,
              font: {
                size: isMobile ? 10 : 12
              }
            }
          }
        }
      }
    });
  }
}
